import React from 'react';
import MotifTypeahead from '@ey/motif-react-wrapper/Typeahead';

export default function Typeahead(props) {
	return <MotifTypeahead {...props} />;
}
